import { AnchorTarget } from '@/components/common/AnchorTarget'
import { usePage } from '@/components/providers/PageProvider'

import { FeaturedComboHeading } from '../FeaturedComboHeading/FeaturedComboHeading'

import styles from './FeaturedComboBracket.module.scss'
import { FeaturedComboBracketBlock } from './FeaturedComboBracketBlock/FeaturedComboBracketBlock'

export const FeaturedComboBracket = () => {
  const { page } = usePage()

  const combo = page?.featuredCombo

  if (!combo) return null

  const { message: lowMessage, status: lowStatus } = combo.bracketInfo.low
  const { message: midMessage, status: midStatus } = combo.bracketInfo.mid

  return (
    <div className={styles.container}>
      <AnchorTarget id='bracket' />
      <FeaturedComboHeading
        heading='Commander Bracket Information'
        icon='bracketsCurly'
        subheading='In which Commander Bracket(s) am I allowed to play this combo?'
      />
      <div className={styles.blocks}>
        <FeaturedComboBracketBlock
          description={lowMessage}
          label='1-2'
          status={lowStatus}
          subtext='(no 2-card combos)'
          title='Exhibition and Core'
        />
        <FeaturedComboBracketBlock
          description={midMessage}
          label='3'
          status={midStatus}
          subtext='(no early game 2-card combos)'
          title='Upgraded'
        />
        <FeaturedComboBracketBlock
          description='All combos are allowed.'
          label='4-5'
          status='valid'
          subtext='(all combos are allowed)'
          title='Optimized and CEDH'
        />
      </div>
    </div>
  )
}
